<template>
  <div class="rounded-2xl border border-gray-100 bg-gray-50/70 p-4">
    <div class="flex flex-col gap-4 sm:flex-row">
      <div
        class="flex h-40 w-full shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm sm:w-48"
      >
        <img
          v-if="preview"
          :src="preview"
          :alt="title"
          class="h-full w-full object-cover"
        />

        <div v-else class="text-center">
          <component :is="icon" class="mx-auto h-10 w-10 text-gray-300" />
          <p class="mt-2 text-xs text-gray-400">Sem arquivo</p>
        </div>
      </div>

      <div class="flex-1">
        <div class="flex items-start justify-between gap-3">
          <div>
            <h3 class="text-sm font-bold text-gray-800">
              {{ title }}
            </h3>

            <p class="mt-1 text-sm text-gray-500">
              {{ description }}
            </p>
          </div>

          <span
            class="rounded-full px-2.5 py-1 text-xs font-semibold"
            :class="
              preview
                ? 'bg-green-50 text-green-700'
                : 'bg-gray-100 text-gray-400'
            "
          >
            {{ preview ? "Configurado" : "Pendente" }}
          </span>
        </div>

        <div class="mt-4 flex flex-wrap items-center gap-2">
          <label
            class="inline-flex cursor-pointer items-center gap-2 rounded-xl border border-green-100 bg-white px-4 py-2.5 text-sm font-semibold text-[#2f8f2f] shadow-sm transition hover:bg-green-50"
          >
            <PhUploadSimple class="h-5 w-5" />
            Selecionar arquivo

            <input
              type="file"
              class="hidden"
              accept="image/png,image/jpeg,image/jpg,image/webp"
              @change="handleChange"
            />
          </label>

          <button
            v-if="preview"
            type="button"
            class="inline-flex items-center gap-2 rounded-xl px-3 py-2.5 text-sm text-gray-400 transition hover:bg-red-50 hover:text-red-600"
            @click="$emit('remove')"
          >
            <PhTrash class="h-4 w-4" />
            Remover
          </button>
        </div>

        <p class="mt-3 text-xs text-gray-400">
          Formatos recomendados: JPG, PNG ou WEBP.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { PhFileImage, PhTrash, PhUploadSimple } from "@phosphor-icons/vue";

defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: "",
  },
  preview: {
    type: String,
    default: "",
  },
  icon: {
    type: [Object, Function],
    default: PhFileImage,
  },
});

const emit = defineEmits(["change", "remove"]);

function handleChange(event) {
  const [file] = event.target.files || [];

  if (!file) return;

  emit("change", file);

  event.target.value = "";
}
</script>
